export interface IWaitListImportSampleRow {
    lineNumber: number,
    data: string[]
}